import { NavLink, Outlet } from "react-router-dom";

const Subscription = () => {
  return (
    <div>
      <nav
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          marginLeft: "1rem",
          display: "flex",
          gap: "1rem",
        }}
      >
        {/* Use NavLink for active tab styling */}
        <NavLink
          to="/content"
          end
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Announcements
        </NavLink>
        <NavLink
          to="/content/offers"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Offers
        </NavLink>
        <NavLink
          to="/content/blogs"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Blogs
        </NavLink>
                {/* <NavLink
          to="/content/countdown"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Countdowns
        </NavLink> */}

      </nav>

      {/* Render child routes here */}
      <Outlet />
    </div>
  );
};

export default Subscription;
